import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=6bbb1e8f&scoped=true"
import script from "./pill.vue?vue&type=script&lang=js"
export * from "./pill.vue?vue&type=script&lang=js"
import style0 from "./pill.vue?vue&type=style&index=0&id=6bbb1e8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb1e8f",
  null
  
)

export default component.exports